import type { FaireProductEntity } from "../../entity_types/product";

export const p_vzzyyg8qhd: FaireProductEntity = {
  token: "p_vzzyyg8qhd",
  type: "product",
  name: "Mixed Case of Retail Tins (6 & 6)",
  brandToken: "b_wlog0i1yg7",
  brandName: "SØUL CHAI",
  imageUrl: "https://cdn.faire.com/fastly/5ae9a5a405aab0b1797305f9e551d36e06d8349dfd66368070bcfa8d4a708954.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fdfebe6f2e3bb570c25e44967178ed60a912e198b57e3f66973a7edc2b8fb181.jpeg",
    "https://cdn.faire.com/fastly/ae36d02fbeab2f7c475233b5ef68e04651c390fb80472576d4634899c6fa61eb.jpeg",
    "https://cdn.faire.com/fastly/2057adf20c1ff58fe867f74f2579be21640202dff1eee844a3768c69ad083bf1.jpeg",
    "https://cdn.faire.com/fastly/fa5fbb20767c0610eccfaf8b98aa9bb35359e42a019cba3a13b070c1f1767a70.png"
  ],
  priceDollars: 14.75,
  description: "Soul Chai for every mood! This case of 12x 80g tins includes 6 Original Masala Chai Powder + 6 Rooibos Masala Chai Powder.",
  tags: [],
  msrpDollars: 22.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:12.039Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
